import React, { memo, ReactNode } from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import useAllRfqHook from './all-rfq.hook';
import * as styled from './all-rfq.styles';
import themes from './themes';
import { Icon } from '@plasma/ui.general.icon';
import EditableTable from '../../components/edit-table';
import TopBar from '../../components/top-bar/top-bar';
import Button from '@plasma/ui.general.button';

export interface AllRfqProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = AllRfqProps & ThemeOverride;

function AllRfq(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const { t, dataForColumns,columnNames,
    handleSaveAndDeleteFromTable} = useAllRfqHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.AllRfq className={`all-rfq ${className ?? ''}`.trim()} style={style}>
      <TopBar
              topHeading="ALL RFQ"
              headingBGColor='#F3AFBB77'
        />

        <div style={{position: 'relative', top: '4em'}}>
        <EditableTable
            tableData={dataForColumns}
            tableColumns={columnNames}
            Table_Header="RFQ STATUS"
            hiddenColumns={['status' ]}
            //stillHiddenColumns = {['id']}
            handleSave={handleSaveAndDeleteFromTable}
            showActions_ext={true}
            allowSelection={false}
            saveReturnType={'row'} stillHiddenColumns={[]} rowIndexSelected={0} handleSelection={function (selectedRowIndex: number, selectedRowData: { [key: string]: any; }, event: React.SyntheticEvent<Element, Event>): void {
              throw new Error('Function not implemented.');
            } }
            onlyAddableFields={[]}
            mandatoryFields={[]}
            selectInputReturnType={'display'}
            allowInsertInitialBlankRow={false}
            clearTheSelection={false}
          //  selectInputReturnType={'value'}
          //onlyAddableFields={['plantcodename', 'companyname','schemaname']}
        />
        </div>


        {children}
      </styled.AllRfq>
    </ThemeProvider>
  );
}

export default memo(AllRfq) as unknown as typeof AllRfq;
